import { IState, IAuthState } from 'types/redux'
import { IUser } from 'types/authView'

export const getUser = ({ auth }: IState): IUser => auth.user

export const getAuth = ({ auth }: IState): IAuthState => auth